module.exports = __webpack_public_path__ + "img/es-vivo-banner.4f4fbe88.png";